import {
  SEARCH_PAGE_PERFORM_SEARCH,
  SEARCH_PAGE_PERFORM_SEARCH_FAILURE,
  SEARCH_PAGE_PERFORM_SEARCH_SUCCESS,
  SET_SEARCH_QUERY,
  SET_PAGE,
  INIT_CATEGORIES,
  INIT_TRANSLATIONS,
  SET_CATEGORY,
  INIT_LANGUAGE,
  SET_CONTACT_TRANSLATIONS
} from './searchPage/actions.mjs';

const initialState = {
  query: '',
  categories: [],
  translations: {},
  searchLoading: false,
  searchError: false,
  category: '',
  page: 1,
  language: null,
  searchResults: {
    total: 0,
    hits: [],
    hitCategories: {},
  },
};

const searchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_QUERY:
      return Object.assign({}, state, {
        query: action.query,
      });
    case SET_CATEGORY:
      return Object.assign({}, state, {
        category: action.category,
      });
    case SET_PAGE:
      return Object.assign({}, state, {
        page: action.page,
      });
    case INIT_CATEGORIES:
      return Object.assign({}, state, {
        categories: action.categories,
      });
    case INIT_LANGUAGE:
      return Object.assign({}, state, {
        language: action.language,
      });
    case INIT_TRANSLATIONS:
      return Object.assign({}, state, {
        translations: action.translations,
      });
    case SET_CONTACT_TRANSLATIONS:
      return Object.assign({}, state, {
        contactTranslations: action.translations,
      });
    case SEARCH_PAGE_PERFORM_SEARCH:
      return Object.assign({}, state, {
        searchLoading: true,
        searchError: false,
      });
    case SEARCH_PAGE_PERFORM_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        searchResults: action.data,
        searchLoading: false,
        searchError: false,
      });
    case SEARCH_PAGE_PERFORM_SEARCH_FAILURE:
      return Object.assign({}, state, {
        searchLoading: false,
        searchError: true,
      });
    default:
      return state;
  }
};

export default searchPageReducer;
